
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcIntegrationButton as ObcIntegrationButtonElement} from '@oicl/openbridge-webcomponents/dist/integration-systems/integration-button/integration-button.js';
 
 
 

 
 export const ObcIntegrationButton = createComponent({
   react: React,
   tagName: 'obc-integration-button',
   elementClass: ObcIntegrationButtonElement,
   events: {
     
   }
  });
 
 